import { render, staticRenderFns } from "./Startseite2.vue?vue&type=template&id=d3426afa&scoped=true&"
import script from "./Startseite2.vue?vue&type=script&lang=js&"
export * from "./Startseite2.vue?vue&type=script&lang=js&"
import style0 from "./Startseite2.vue?vue&type=style&index=0&id=d3426afa&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3426afa",
  null
  
)

export default component.exports